import React from "react";
import { Link } from "react-router-dom";
import { payCancel } from "../../assets";

const PaymentFailed = () => {
  return (
    <div className="pay-failed">
      <img src={payCancel} alt="" />
      <div>
        <p>Payment Error</p>
        <small>Don't Worry. We will contact you soon.</small>
        <Link to="/">Back to Home</Link>
      </div>
    </div>
  );
};

export default PaymentFailed;
